/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import serverClientUtil from '../../../../../utils/serverClientUtil';
import ApplyCSS from '../../../../../components/ApplyCSS';
import commonUtil from '../../../../../utils/commonUtil';


@connect(store => ({
  user: store.user.data,
  cartCountData: store.cartCountData.data,
}),
)

class HeaderPB extends Component {
  redirectToLoginPage = () => {
    const url = serverClientUtil.getLPFullURL();
    const redirectUrl = 'https:' + url + '/login';
    const redirectBackUrl = window.location.origin;
    window.location.replace(
      `${redirectUrl}?redirectAfterLoginHref=${redirectBackUrl}&originalRedirectHref=${window.location.origin}`,
    );
  }
  render() {
    this.cartCount = 0;
    if (this.props.cartCountData && this.props.cartCountData.cartDetails && this.props.cartCountData.cartDetails.length > 0) {
      this.props.cartCountData.cartDetails.map(data => this.cartCount += parseInt(data.quantity, 10));
    }
    const isUserLoggedIn = !!(this.props.user && this.props.user.result && this.props.user.result.emailId);
    return (
      <div className="container">
        <ApplyCSS pageName="headerPB" />
        <div className="row">
          <div className="col-xs-12 pl-0 pr-0">
            <div className="col-xs-2 returnIcon" onClick={(e) => { this.props.returnClickHandler(e); }}>
              <span className="icon-flecha_header_izquierda" />
            </div>
            <div className="col-xs-7 pl-0" id="logoContainer">
              <a href={serverClientUtil.getLPFullURL()}><img src={commonUtil.getAssetURL() + '/images/logos/logo-pb.png'} />
              </a>
            </div>
            <div className="col-xs-3 bagWrapper">
              {!isUserLoggedIn ? <a className="user" onClick={this.redirectToLoginPage}><span className="icon-iconos-perfil" /> </a> : null}
              <a href={serverClientUtil.getLPFullURL() + '/cart'}>
                <span className="icon-bolsita icon-bolsita-position-one">
                  <div className="cart-bubble">{this.cartCount > 0 ? this.cartCount : null}</div>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HeaderPB;

